import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const ifaSelectProductTypeFeatureKey = 'ifaSelectProductType';

export interface IfaSelectProductTypeState {
  ifaSelectProductType: string;
}

export const initialState: IfaSelectProductTypeState = {
  ifaSelectProductType: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadIfaSelectProductType, (state, action) => ({
    ...state,
    ifaSelectProductType: action.productId
  }))
);

export const getIfaProductType = (state: IfaSelectProductTypeState) => state.ifaSelectProductType;
